import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    item: {
        "&.MuiButtonBase-root": {
            fontSize: theme.typography.subtitle2.fontSize,
            fontFamily: theme.typography.subtitle2.fontFamily,
            color: theme.palette.text.primary,
            boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: "5px",
        },
    },
}));

export const paperPropsStyles = {
    maxHeight: 48 * 4.5,
    minWidth: "20ch",
    padding: "10px",
};
